import { ArrowLeftSmall as ArrowLeftSmall_kojaro } from './ArrowLeftSmall.kojaro';
import { ArrowLeftSmall as ArrowLeftSmall_phosphor } from './ArrowLeftSmall.phosphor';
import { ArrowLeftSmall as ArrowLeftSmall_zoomg } from './ArrowLeftSmall.zoomg';
import { ArrowLeftSmall as ArrowLeftSmall_zoomit } from './ArrowLeftSmall.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return ArrowLeftSmall_kojaro;

    case 'zoomg':
      return ArrowLeftSmall_zoomg;

    case 'phosphor':
      return ArrowLeftSmall_phosphor;

    default:
      return ArrowLeftSmall_zoomit;
  }
};

export const ArrowLeftSmall = IconRenderer();
